import { createRequiredContext } from "utils/createRequiredContext";
import { use } from "react";
import type { useBulkRequestFilter } from "./useBulkRequestFilter";

/** Bulk request filter context. See useBulkRequestFilter. */
export const BulkRequestFilterContext = createRequiredContext<ReturnType<typeof useBulkRequestFilter>>(
    "BulkRequestFilterContext required",
);
BulkRequestFilterContext.displayName = "Bulk Request Filter Context";

/** Hook to gain access to bulk request filtering state. */
export function useBulkRequestFilterContext() {
    return use(BulkRequestFilterContext);
}
